<dx-popup
  #popupSubjectVisualizer
  [title]="title"
  [width]="800"
  [height]="500"
  [minWidth]="400"
  [minHeight]="300"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  position="center"
  [(visible)]="isPopupVisible"
  (onResizeStart)="onResizeStart($event)"
  (onResizeEnd)="onResizeEnd($event)"  
>
  <!-- <dxi-toolbar-item
    widget="dxButton"
    location="after"
    [options]="{        
        onClick: toggleFullScreen,
        text:'fs',
    }"
  >
  </dxi-toolbar-item> -->

  <div *dxTemplate="let data of 'content'">
    <div>
      Hold Left Mouse Button down to Pan or Move Selected Entity, Mouse Wheel to Zoom, Right Mouse
      Button for Context Menu
    </div>
    <div      
      #divGraph
      style="width: 100%; height: 100%"
      id="divGraph"
    >      
    </div>
    <!-- <dx-load-panel
        #loadPanel
        shadingColor="rgba(0,0,0,0.4)"
        [visible]="bLoading"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [hideOnOutsideClick]="false"
      >
      </dx-load-panel> -->

    <dx-context-menu
      [dataSource]="menuItems"
      [width]="200"
      [hideOnOutsideClick]="true"
      (onItemClick)="itemClick($event)"
    >
    </dx-context-menu>
  </div>
</dx-popup>
